import { WebWeeklyViewPage } from './../pages/web-weekly-view/web-weekly-view';
import { ADViewPage } from './../pages/ad-view/ad-view';
import { AlertController } from 'ionic-angular/components/alert/alert-controller';
import { NetworkConnectionProvider } from './../providers/network-connection/network-connection';
import { Keyboard } from '@ionic-native/keyboard';
import { TimeReportingPage } from './../pages/time-reporting/time-reporting';
import { Component, ViewChild } from '@angular/core';
import { Nav, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { WeekViewPage } from './../pages/week-view/week-view';
import { LoginPage } from './../pages/login/login';
import { FilterViewPage } from '../pages/filter-view/filter-view';

//services
import { CoreProvider } from '../providers/core-service/core-service';
import { Subscription } from 'rxjs/Subscription';
import { Messages } from '../constants/messages';
import { InAppBrowserOptions, InAppBrowser } from '@ionic-native/in-app-browser';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  options: InAppBrowserOptions = {
    location: 'yes',//Or 'no' 
    hidden: 'no', //Or  'yes'
    clearcache: 'yes',
    clearsessioncache: 'yes',
    zoom: 'yes',//Android only ,shows browser zoom controls 
    hardwareback: 'yes',
    mediaPlaybackRequiresUserAction: 'no',
    shouldPauseOnSuspend: 'no', //Android only 
    closebuttoncaption: 'Close', //iOS only
    disallowoverscroll: 'no', //iOS only 
    toolbar: 'yes', //iOS only 
    enableViewportScale: 'no', //iOS only 
    allowInlineMediaPlayback: 'no',//iOS only 
    presentationstyle: 'pagesheet',//iOS only 
    fullscreen: 'yes',//Windows only    
  };

  appVersion: string = '1.1.7';

  private loginBinding: Subscription;
  private userBinding: Subscription;

  rootPage: any = WebWeeklyViewPage;
  weekPassedNotConfirm = false; //true if not confirmed
  activePage: number = 0;

  privacy_label = 'PRIVACY';
  privacy_url = 'htpp://'

  user: any = {};

  pages: Array<{ title: string, component: any, icon: string, index: number }>;
  pagesAD: Array<{ title: string, component: any, icon: string, index: number }>;

  constructor(public platform: Platform,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    private core: CoreProvider,
    private net: NetworkConnectionProvider,
    private inAppBrow: InAppBrowser,
    private keyboard: Keyboard,
    private alertCtrl: AlertController) {

    this.initializeApp();

    // used for an example of ngFor and navigation
    this.pages = [
      { title: 'Weekly View', component: WeekViewPage, icon: "perm_contact_calendar", index: 0 },
      { title: 'Time Reporting', component: TimeReportingPage, icon: "access_time", index: 1 },
      { title: 'Filter View', component: FilterViewPage, icon: "line_weight", index: 2 }
    ];

    this.pagesAD = [
      { title: 'Weekly View', component: WeekViewPage, icon: "perm_contact_calendar", index: 0 },
      { title: 'Time Reporting', component: TimeReportingPage, icon: "access_time", index: 1 },
      { title: 'Filter View', component: FilterViewPage, icon: "line_weight", index: 2 },
      { title: 'LEAVE & TRAVEL', component: ADViewPage, icon: "time_to_leave", index: 3 }
    ];

  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.

      /*this.core.setDevice(this.platform.height(), this.platform.width());
      this.statusBar.styleDefault();

      this.statusBar.styleLightContent();
      this.splashScreen.hide();*/

      this.loginBinding = this.core.init().subscribe(auth => {

        if (auth) {
          //console.log('autenticato');

          this.userBinding = this.core.getUserData().filter(x => x).subscribe(user => {
            //console.log('autenticato: ' + user.key);
            //console.log(user);

            if (user) {
              this.user = user;

              this.privacy_label = this.core.configuration.label_privacy;
              this.privacy_url = this.core.configuration.url_privacy;

              if (this.core.actualTimeDate.getDay() < this.core.configuration.showBadgeFrom) {

                this.core.checkConfirmPreviousWeek(user.key).subscribe(result => {
                  //console.log('previous ' + !result);
                  this.weekPassedNotConfirm = !result;
                });
              } else {
                this.core.checkConfirmWeek(user.key).subscribe(result => {
                  //console.log('current ' + !result);

                  this.weekPassedNotConfirm = !result;
                });
              }

              if (user.canSeeLeaveTravel) {
                this.pages = this.pagesAD;
              } else { //modifica per bug dopo logout e login
                this.pages = this.pages;
              }
              // this.nav.setRoot(WeekViewPage);
            }

            if (this.nav.getActive().name != WebWeeklyViewPage.name)
              this.nav.setRoot(WebWeeklyViewPage);

          }, err => {

            //console.log(err);
          });

        } else {
          //console.log('non autenticato');

          if (this.userBinding)
            this.userBinding.unsubscribe();

          this.nav.setRoot(LoginPage);
          //
        }
      }, err => {
        //console.log(err);
      });


      this.keyboard.onKeyboardShow().subscribe(result => {
        document.body.classList.add('keyboard-is-open');
        //console.log('footer hide');

      });

      this.keyboard.onKeyboardHide().subscribe(result => {

        document.body.classList.remove('keyboard-is-open');
        //console.log('footer show');

      });

    });
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.activePage = page.index;
    if (page.index == 1)
      this.nav.setRoot(page.component, { resetDate: true, userdata: this.user });
    else
      this.nav.setRoot(page.component, { resetDate: true });
  }

  logout() {
    if (!this.net.verifyConnection()) {
      this.core.showToast(Messages.offline, 'bottom');
    } else {

      let alert = this.alertCtrl.create({
        title: 'Confirm Logout?',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel'
          },
          {
            text: 'OK',
            handler: () => {
              this.core.logout().then(result => {
                //console.log('logout');
              });
            }
          }
        ]
      });
      alert.present();
    }

  }

  weekPassedCheck(): boolean {
    return this.weekPassedNotConfirm;
  }

  openPrivacy() {

    let target = "_blank";
    this.inAppBrow.create(this.privacy_url, target, this.options);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts